var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-steps",
        {
          attrs: {
            active: _vm.activeStep,
            "finish-status": "success",
            simple: ""
          }
        },
        [
          _c("el-step", { attrs: { title: "选择游戏平台" } }),
          _c("el-step", { attrs: { title: "参数配置" } }),
          _c("el-step", { attrs: { title: "确认打包" } }),
          _c("el-step", { attrs: { title: "打包" } })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "step-content" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 0 || _vm.activeStep === 2,
                  expression: "activeStep === 0 || activeStep === 2"
                }
              ],
              ref: "step1Form",
              staticClass: "popover",
              staticStyle: { "min-height": "300px" },
              attrs: {
                model: _vm.formData.step1,
                rules: _vm.rules.step1,
                "label-width": "100px",
                "label-position": "center"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: "游戏组", prop: "game_group_id" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.activeStep === 2,
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择游戏组"
                      },
                      model: {
                        value: _vm.formData.step1.game_group_id,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.step1, "game_group_id", $$v)
                        },
                        expression: "formData.step1.game_group_id"
                      }
                    },
                    _vm._l(_vm.gameGroupList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.group_name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: "母包", prop: "original_package_id" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.activeStep === 2,
                        clearable: "",
                        filterable: "",
                        placeholder: "母包"
                      },
                      model: {
                        value: _vm.formData.step1.original_package_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formData.step1,
                            "original_package_id",
                            $$v
                          )
                        },
                        expression: "formData.step1.original_package_id"
                      }
                    },
                    _vm._l(_vm.originPkgList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.package_name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: "渠道", prop: "original_package_type_id" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.activeStep === 2,
                        clearable: "",
                        filterable: "",
                        placeholder: "母包类型"
                      },
                      on: { change: _vm.pkgTypeChange },
                      model: {
                        value: _vm.formData.step1.original_package_type_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formData.step1,
                            "original_package_type_id",
                            $$v
                          )
                        },
                        expression: "formData.step1.original_package_type_id"
                      }
                    },
                    _vm._l(_vm.originPkgTypeList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.type_name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_delay", label: "定时发送" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.activeStep === 2,
                        placeholder: "请选择是否定时发送"
                      },
                      model: {
                        value: _vm.formData.step1.is_delay,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.step1, "is_delay", $$v)
                        },
                        expression: "formData.step1.is_delay"
                      }
                    },
                    _vm._l(_vm.timing, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.formData.step1.is_delay == 1
                ? _c(
                    "el-form-item",
                    {
                      key: "delay_time",
                      staticClass: "lodingItem",
                      attrs: { prop: "delay_time", label: "发送时间" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled: _vm.activeStep === 2,
                          "popper-class": "no-atTheMoment",
                          "value-format": "timestamp",
                          type: "datetime",
                          placeholder: "日期"
                        },
                        model: {
                          value: _vm.formData.step1.delay_time,
                          callback: function($$v) {
                            _vm.$set(_vm.formData.step1, "delay_time", $$v)
                          },
                          expression: "formData.step1.delay_time"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: "应用列表", prop: "app_id" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.activeStep === 2,
                        clearable: "",
                        filterable: "",
                        placeholder: "应用列表"
                      },
                      model: {
                        value: _vm.formData.step1.app_id,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.step1, "app_id", $$v)
                        },
                        expression: "formData.step1.app_id"
                      }
                    },
                    _vm._l(_vm.appList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "icon",
                  staticClass: "lodingItem",
                  attrs: { prop: "icon", label: "图标选择" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.activeStep === 2,
                        placeholder: "选择图片"
                      },
                      model: {
                        value: _vm.formData.step1.icon,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.step1, "icon", $$v)
                        },
                        expression: "formData.step1.icon"
                      }
                    },
                    _vm._l(_vm.iconList, function(item) {
                      return _c("el-option", {
                        key: item.desc,
                        attrs: { label: item.desc, value: item.url }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 1 || _vm.activeStep === 2,
                  expression: "activeStep === 1 || activeStep === 2"
                }
              ],
              ref: "step3Form",
              staticClass: "popover",
              attrs: {
                model: _vm.formData.otherParams,
                rules: _vm.rules.otherParams,
                "label-width": "100px",
                "label-position": "center"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "game", label: "游戏标志符" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.activeStep === 2,
                      clearable: "",
                      placeholder: "请输入"
                    },
                    model: {
                      value: _vm.formData.otherParams.game,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.otherParams, "game", $$v)
                      },
                      expression: "formData.otherParams.game"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "platform", label: "平台标志符" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.activeStep === 2,
                      clearable: "",
                      placeholder: "请输入"
                    },
                    model: {
                      value: _vm.formData.otherParams.platform,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.otherParams, "platform", $$v)
                      },
                      expression: "formData.otherParams.platform"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "channel", label: "渠道标志符" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.activeStep === 2,
                      clearable: "",
                      placeholder: "请输入"
                    },
                    model: {
                      value: _vm.formData.otherParams.channel,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.otherParams, "channel", $$v)
                      },
                      expression: "formData.otherParams.channel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "pkg", label: "包名" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.activeStep === 2,
                      clearable: "",
                      placeholder: "请输入"
                    },
                    model: {
                      value: _vm.formData.otherParams.pkg,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.otherParams, "pkg", $$v)
                      },
                      expression: "formData.otherParams.pkg"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "ad_channel", label: "广告渠道" }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.formData.otherParams.ad_channel,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.otherParams, "ad_channel", $$v)
                      },
                      expression: "formData.otherParams.ad_channel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "ad_placement", label: "广告位置" }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.formData.otherParams.ad_placement,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.otherParams, "ad_placement", $$v)
                      },
                      expression: "formData.otherParams.ad_placement"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 1 || _vm.activeStep === 2,
                  expression: "activeStep === 1 || activeStep === 2"
                }
              ],
              attrs: {
                model: _vm.formData.sdkParams,
                rules: _vm.rules.sdkParams,
                "label-width": "110px",
                "label-position": "center"
              }
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: {
                    disabled: _vm.activeStep === 2,
                    type: _vm.chooseStatus.includes("third") ? "primary" : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.getType("third")
                    }
                  }
                },
                [_vm._v("三方SDK")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.activeStep === 2,
                    type: _vm.chooseStatus.includes("adversting")
                      ? "primary"
                      : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.getType("adversting")
                    }
                  }
                },
                [_vm._v("广告SDK")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.activeStep === 2,
                    type: _vm.chooseStatus.includes("packing") ? "primary" : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.getType("packing")
                    }
                  }
                },
                [_vm._v("打包签名文件")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.activeStep === 2,
                    type: _vm.chooseStatus.includes("oaid") ? "primary" : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.getType("oaid")
                    }
                  }
                },
                [_vm._v("oaid文件按钮")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.activeStep === 2,
                    type: _vm.chooseStatus.includes("reportParams")
                      ? "primary"
                      : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.getType("reportParams")
                    }
                  }
                },
                [_vm._v("上报渠道")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.activeStep === 2,
                    type: _vm.chooseStatus.includes("oneClickLogin")
                      ? "primary"
                      : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.getType("oneClickLogin")
                    }
                  }
                },
                [_vm._v("一键登录")]
              ),
              _vm.chooseStatus.includes("third")
                ? _c(
                    "div",
                    { staticClass: "mr10 disF" },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: { prop: "sdkType", label: "三方SDK类型" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  on: { change: _vm.getSDK },
                                  model: {
                                    value: _vm.formData.sdkParams.sdkType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData.sdkParams,
                                        "sdkType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.sdkParams.sdkType"
                                  }
                                },
                                _vm._l(_vm.otherSdkTypeList, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.sdk_name,
                                      value:
                                        item.id +
                                        "、" +
                                        item.sdk_type +
                                        "、" +
                                        item.params
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: {
                                prop: "sdk_download_url",
                                label: "三方SDK"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  model: {
                                    value:
                                      _vm.formData.sdkParams.sdk_download_url,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData.sdkParams,
                                        "sdk_download_url",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.sdkParams.sdk_download_url"
                                  }
                                },
                                _vm._l(_vm.otherSdkList, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.sdk_version,
                                      value: item.sdk_url
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.formData.sdkParams.params, function(
                        domain,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index + "k", staticClass: "param_keysClass" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "lodingItem-operationFrame flex",
                                staticStyle: { "flex-wrap": "wrap" }
                              },
                              [
                                domain.typeValue == "number"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "params." + index + ".numberKey",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              clearable: "",
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: domain.numberKey,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "numberKey",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.numberKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "250px" },
                                          attrs: {
                                            prop:
                                              "params." + index + ".numberVal",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: _vm.activeStep === 2,
                                              placeholder: "此处可填默认值"
                                            },
                                            model: {
                                              value: domain.numberVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "numberVal",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.numberVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "boolean"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "params." + index + ".booleanKey",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              clearable: "",
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: domain.booleanKey,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "booleanKey",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.booleanKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "250px" },
                                          attrs: {
                                            prop:
                                              "params." + index + ".booleanVal",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: _vm.activeStep === 2,
                                              placeholder: "此处可填默认值"
                                            },
                                            model: {
                                              value: domain.booleanVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "booleanVal",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.booleanVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "string"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "params." + index + ".stringKey",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: domain.stringKey,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "stringKey",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.stringKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "250px" },
                                          attrs: {
                                            prop:
                                              "params." + index + ".stringVal",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: _vm.activeStep === 2
                                            },
                                            model: {
                                              value: domain.stringVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "stringVal",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.stringVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "map"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "params." + index + ".mapParams",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              placeholder: "请输入对象名称"
                                            },
                                            model: {
                                              value: domain.mapParams,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "mapParams",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.mapParams"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._l(domain.mapData, function(
                                        item,
                                        idx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx + "kl",
                                            staticClass: "flex-array-item"
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "btn-type",
                                                attrs: {
                                                  prop:
                                                    "params." +
                                                    index +
                                                    ".mapData." +
                                                    idx +
                                                    ".key",
                                                  "label-width": "0px"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass:
                                                    "operationFrame-entity",
                                                  attrs: {
                                                    disabled: true,
                                                    placeholder: "请输入"
                                                  },
                                                  model: {
                                                    value: item.key,
                                                    callback: function($$v) {
                                                      _vm.$set(item, "key", $$v)
                                                    },
                                                    expression: "item.key"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "btn-type",
                                                attrs: {
                                                  prop:
                                                    "params." +
                                                    index +
                                                    ".mapData." +
                                                    idx +
                                                    ".value",
                                                  "label-width": "0px"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass:
                                                    "operationFrame-entity",
                                                  attrs: {
                                                    disabled:
                                                      _vm.activeStep === 2,
                                                    placeholder: "请输入"
                                                  },
                                                  model: {
                                                    value: item.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "array"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "params." +
                                              index +
                                              ".arrayParams",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              placeholder: "请输入列表名称"
                                            },
                                            model: {
                                              value: domain.arrayParams,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "arrayParams",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.arrayParams"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._l(domain.arrayData, function(
                                        item,
                                        idx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx + "kl",
                                            staticClass: "flex-array-item",
                                            staticStyle: {
                                              "flex-direction": "column"
                                            }
                                          },
                                          [
                                            _c("div", { staticClass: "line" }),
                                            _vm._l(
                                              item.arrChildrenItem,
                                              function(m, k) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-array-item",
                                                    staticStyle: {
                                                      "align-items": "center"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticClass: "btn-type",
                                                        attrs: {
                                                          prop:
                                                            "params." +
                                                            index +
                                                            ".arrayData." +
                                                            idx +
                                                            ".arrChildrenItem." +
                                                            k +
                                                            ".key",
                                                          "label-width": "0px"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticClass:
                                                            "operationFrame-entity",
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入",
                                                            disabled: true
                                                          },
                                                          model: {
                                                            value: m.key,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                m,
                                                                "key",
                                                                $$v
                                                              )
                                                            },
                                                            expression: "m.key"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticClass: "btn-type",
                                                        attrs: {
                                                          prop:
                                                            "params." +
                                                            index +
                                                            ".arrayData." +
                                                            idx +
                                                            ".arrChildrenItem." +
                                                            k +
                                                            ".value",
                                                          "label-width": "0px"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticClass:
                                                            "operationFrame-entity",
                                                          attrs: {
                                                            disabled:
                                                              _vm.activeStep ===
                                                              2,
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入"
                                                          },
                                                          model: {
                                                            value: m.value,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                m,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "m.value"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      _c("div", { staticClass: "line" })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.chooseStatus.includes("adversting")
                ? _c(
                    "div",
                    { staticClass: "mr10 disF" },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: {
                                prop: "advSdkType",
                                label: "广告SDK类型"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  on: { change: _vm.getAdverSDK },
                                  model: {
                                    value: _vm.formData.sdkParams.advSdkType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData.sdkParams,
                                        "advSdkType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.sdkParams.advSdkType"
                                  }
                                },
                                _vm._l(_vm.adChannelSdkTypeList, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.sdk_name,
                                      value:
                                        item.id +
                                        "、" +
                                        item.sdk_type +
                                        "、" +
                                        item.params
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: {
                                prop: "adv_sdk_url_ver",
                                label: "广告SDK"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  on: { change: _vm.getAdverSDKUrlVer },
                                  model: {
                                    value:
                                      _vm.formData.sdkParams.adv_sdk_url_ver,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData.sdkParams,
                                        "adv_sdk_url_ver",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.sdkParams.adv_sdk_url_ver"
                                  }
                                },
                                _vm._l(_vm.adChannelSdkManageList, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.sdk_version,
                                      value:
                                        item.sdk_url + "," + item.sdk_version
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.formData.sdkParams.advertisingParams, function(
                        domain,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index + "k", staticClass: "param_keysClass" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "lodingItem-operationFrame flex",
                                staticStyle: { "flex-wrap": "wrap" }
                              },
                              [
                                domain.typeValue == "number"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".numberKey",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              clearable: "",
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: domain.numberKey,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "numberKey",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.numberKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "250px" },
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".numberVal",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: _vm.activeStep === 2,
                                              placeholder: "此处可填默认值"
                                            },
                                            model: {
                                              value: domain.numberVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "numberVal",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.numberVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "boolean"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".booleanKey",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              clearable: "",
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: domain.booleanKey,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "booleanKey",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.booleanKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "250px" },
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".booleanVal",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: _vm.activeStep === 2,
                                              placeholder: "此处可填默认值"
                                            },
                                            model: {
                                              value: domain.booleanVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "booleanVal",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.booleanVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "string"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".stringKey",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: domain.stringKey,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "stringKey",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.stringKey"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "250px" },
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".stringVal",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: _vm.activeStep === 2
                                            },
                                            model: {
                                              value: domain.stringVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "stringVal",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.stringVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "map"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".mapParams",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              placeholder: "请输入对象名称"
                                            },
                                            model: {
                                              value: domain.mapParams,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "mapParams",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.mapParams"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._l(domain.mapData, function(
                                        item,
                                        idx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx + "kl",
                                            staticClass: "flex-array-item"
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "btn-type",
                                                attrs: {
                                                  prop:
                                                    "advertisingParams." +
                                                    index +
                                                    ".mapData." +
                                                    idx +
                                                    ".key",
                                                  "label-width": "0px"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass:
                                                    "operationFrame-entity",
                                                  attrs: {
                                                    disabled: true,
                                                    placeholder: "请输入"
                                                  },
                                                  model: {
                                                    value: item.key,
                                                    callback: function($$v) {
                                                      _vm.$set(item, "key", $$v)
                                                    },
                                                    expression: "item.key"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "btn-type",
                                                attrs: {
                                                  prop:
                                                    "advertisingParams." +
                                                    index +
                                                    ".mapData." +
                                                    idx +
                                                    ".value",
                                                  "label-width": "0px"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass:
                                                    "operationFrame-entity",
                                                  attrs: {
                                                    disabled:
                                                      _vm.activeStep === 2,
                                                    placeholder: "请输入"
                                                  },
                                                  model: {
                                                    value: item.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ]
                                  : _vm._e(),
                                domain.typeValue == "array"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "advertisingParams." +
                                              index +
                                              ".arrayParams",
                                            "label-width": "0px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              disabled: true,
                                              placeholder: "请输入列表名称"
                                            },
                                            model: {
                                              value: domain.arrayParams,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  domain,
                                                  "arrayParams",
                                                  $$v
                                                )
                                              },
                                              expression: "domain.arrayParams"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._l(domain.arrayData, function(
                                        item,
                                        idx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx + "kl",
                                            staticClass: "flex-array-item",
                                            staticStyle: {
                                              "flex-direction": "column"
                                            }
                                          },
                                          [
                                            _c("div", { staticClass: "line" }),
                                            _vm._l(
                                              item.arrChildrenItem,
                                              function(m, k) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-array-item",
                                                    staticStyle: {
                                                      "align-items": "center"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticClass: "btn-type",
                                                        attrs: {
                                                          prop:
                                                            "advertisingParams." +
                                                            index +
                                                            ".arrayData." +
                                                            idx +
                                                            ".arrChildrenItem." +
                                                            k +
                                                            ".key",
                                                          "label-width": "0px"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticClass:
                                                            "operationFrame-entity",
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入",
                                                            disabled: true
                                                          },
                                                          model: {
                                                            value: m.key,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                m,
                                                                "key",
                                                                $$v
                                                              )
                                                            },
                                                            expression: "m.key"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticClass: "btn-type",
                                                        attrs: {
                                                          prop:
                                                            "advertisingParams." +
                                                            index +
                                                            ".arrayData." +
                                                            idx +
                                                            ".arrChildrenItem." +
                                                            k +
                                                            ".value",
                                                          "label-width": "0px"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticClass:
                                                            "operationFrame-entity",
                                                          attrs: {
                                                            disabled:
                                                              _vm.activeStep ===
                                                              2,
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入"
                                                          },
                                                          model: {
                                                            value: m.value,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                m,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "m.value"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      _c("div", { staticClass: "line" })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.chooseStatus.includes("packing")
                ? _c("div", { staticClass: "mr10 disF" }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            attrs: { prop: "sdkType", label: "三方SDK类型" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.activeStep === 2,
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择"
                                },
                                on: { change: _vm.getSDKNew },
                                model: {
                                  value: _vm.formData.sdk_pem_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "sdk_pem_type", $$v)
                                  },
                                  expression: "formData.sdk_pem_type"
                                }
                              },
                              _vm._l(_vm.otherSdkTypeList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.sdk_name,
                                    value: item.id + "、" + item.sdk_type
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            attrs: {
                              prop: "key_store.path",
                              label: "签名文件列表"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.activeStep === 2,
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择"
                                },
                                on: { change: _vm.getPacking },
                                model: {
                                  value: _vm.formData.sdkParams.key_store.path,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData.sdkParams.key_store,
                                      "path",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.sdkParams.key_store.path"
                                }
                              },
                              _vm._l(_vm.sdkPemManageList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.file_version,
                                    value: item.sdk_pem_url
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "popover" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: { width: "50%" },
                            attrs: {
                              prop: "key_store.path",
                              "label-width": "100px",
                              label: "path"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: { disabled: true, placeholder: "请输入" },
                              model: {
                                value: _vm.formData.sdkParams.key_store.path,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.sdkParams.key_store,
                                    "path",
                                    $$v
                                  )
                                },
                                expression: "formData.sdkParams.key_store.path"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: { width: "50%" },
                            attrs: {
                              prop: "key_store.store_pass",
                              "label-width": "100px",
                              label: "store_pass"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                disabled: _vm.activeStep === 2,
                                placeholder: "请输入"
                              },
                              model: {
                                value:
                                  _vm.formData.sdkParams.key_store.store_pass,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.sdkParams.key_store,
                                    "store_pass",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.sdkParams.key_store.store_pass"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: { width: "50%" },
                            attrs: {
                              prop: "key_store.key_pass",
                              "label-width": "100px",
                              label: "key_pass"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                disabled: _vm.activeStep === 2,
                                placeholder: "请输入"
                              },
                              model: {
                                value:
                                  _vm.formData.sdkParams.key_store.key_pass,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.sdkParams.key_store,
                                    "key_pass",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.sdkParams.key_store.key_pass"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: { width: "50%" },
                            attrs: {
                              prop: "key_store.alias",
                              "label-width": "100px",
                              label: "alias"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                disabled: _vm.activeStep === 2,
                                placeholder: "请输入"
                              },
                              model: {
                                value: _vm.formData.sdkParams.key_store.alias,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.sdkParams.key_store,
                                    "alias",
                                    $$v
                                  )
                                },
                                expression: "formData.sdkParams.key_store.alias"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "line" })
                  ])
                : _vm._e(),
              _vm.chooseStatus.includes("oaid")
                ? _c("div", { staticClass: "mr10 disF" }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            attrs: {
                              prop: "oaid_cert_download_url",
                              label: "oaid文件列表"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.activeStep === 2,
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择"
                                },
                                model: {
                                  value:
                                    _vm.formData.sdkParams
                                      .oaid_cert_download_url,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData.sdkParams,
                                      "oaid_cert_download_url",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.sdkParams.oaid_cert_download_url"
                                }
                              },
                              _vm._l(_vm.oaidConfigManageList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.file_version,
                                    value: item.sdk_url
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "line" })
                  ])
                : _vm._e(),
              _vm.chooseStatus.includes("reportParams")
                ? _c(
                    "div",
                    { staticClass: "mr10 disF" },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: {
                                prop: "checkReportParams",
                                label: "选择上报渠道"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    multiple: "",
                                    "collapse-tags": "",
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  on: { change: _vm.getReportParams },
                                  model: {
                                    value:
                                      _vm.formData.sdkParams.checkReportParams,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData.sdkParams,
                                        "checkReportParams",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.sdkParams.checkReportParams"
                                  }
                                },
                                _vm._l(_vm.reportConfigList, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.report_name,
                                      value: item.id
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: _vm.formData.sdkParams.reportListName,
                                "label-width": "10px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: {
                                  disabled: true,
                                  clearable: "",
                                  placeholder: "请输入列表名称"
                                },
                                model: {
                                  value: _vm.formData.sdkParams.reportListName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData.sdkParams,
                                      "reportListName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.sdkParams.reportListName"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn fix-btn",
                            attrs: {
                              disabled: _vm.activeStep === 2,
                              size: "mini",
                              type: "primary",
                              circle: "",
                              icon: "el-icon-plus"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addArrayData()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.formData.sdkParams.reportData, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: index + "k2",
                            staticClass: "flex-array-item",
                            staticStyle: { "flex-direction": "column" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "reportData." + index + ".reportKey",
                                      "label-width": "10px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "operationFrame-entity",
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        placeholder: "请输入上报渠道名称"
                                      },
                                      model: {
                                        value: item.reportKey,
                                        callback: function($$v) {
                                          _vm.$set(item, "reportKey", $$v)
                                        },
                                        expression: "item.reportKey"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "reportData." + index + ".reportVal",
                                      "label-width": "10px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "operationFrame-entity",
                                      attrs: {
                                        disabled: _vm.activeStep === 2,
                                        placeholder: "此处可填默认值"
                                      },
                                      model: {
                                        value: item.reportVal,
                                        callback: function($$v) {
                                          _vm.$set(item, "reportVal", $$v)
                                        },
                                        expression: "item.reportVal"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("el-button", {
                                  staticClass: "delete-btn fix-btn",
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    size: "mini",
                                    type: "danger",
                                    circle: "",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeItemContent(index)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "10px" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "select-type",
                                    attrs: {
                                      disabled: _vm.activeStep === 2,
                                      clearable: "",
                                      filterable: "",
                                      placeholder: "类型"
                                    },
                                    model: {
                                      value: _vm.typeArrayValue,
                                      callback: function($$v) {
                                        _vm.typeArrayValue = $$v
                                      },
                                      expression: "typeArrayValue"
                                    }
                                  },
                                  _vm._l(_vm.typeArrayList, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("el-button", {
                                  staticClass: "delete-btn",
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    size: "mini",
                                    type: "primary",
                                    circle: "",
                                    icon: "el-icon-plus"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.addArrayItemData(index)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._l(item.arrayData, function(m, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx + "k3",
                                  staticClass: "flex-array-item",
                                  staticStyle: { "align-items": "center" }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "btn-type",
                                      attrs: {
                                        prop:
                                          "reportData." +
                                          index +
                                          ".arrayData." +
                                          idx +
                                          ".key",
                                        "label-width": "10px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "operationFrame-entity",
                                        attrs: {
                                          disabled: _vm.activeStep === 2,
                                          clearable: "",
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: m.key,
                                          callback: function($$v) {
                                            _vm.$set(m, "key", $$v)
                                          },
                                          expression: "m.key"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "btn-type",
                                      attrs: {
                                        prop:
                                          "reportData." +
                                          index +
                                          ".arrayData." +
                                          idx +
                                          ".value",
                                        "label-width": "10px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "operationFrame-entity",
                                        attrs: {
                                          disabled: _vm.activeStep === 2,
                                          clearable: "",
                                          placeholder: "此处可填默认值"
                                        },
                                        model: {
                                          value: m.value,
                                          callback: function($$v) {
                                            _vm.$set(m, "value", $$v)
                                          },
                                          expression: "m.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-button", {
                                    staticClass: "delete-btn",
                                    attrs: {
                                      disabled: _vm.activeStep === 2,
                                      size: "mini",
                                      type: "danger",
                                      circle: "",
                                      icon: "el-icon-delete"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.removeArrayItem(index, idx)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      }),
                      _c("div", { staticClass: "line" })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.chooseStatus.includes("oneClickLogin")
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem",
                          staticStyle: { width: "50%" },
                          attrs: {
                            prop: "sora_quick_id",
                            "label-width": "100px",
                            label: "businessID"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "operationFrame-entity",
                            attrs: {
                              disabled: _vm.activeStep === 2,
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.formData.sdkParams.sora_quick_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formData.sdkParams,
                                  "sora_quick_id",
                                  $$v
                                )
                              },
                              expression: "formData.sdkParams.sora_quick_id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeStep === 1 || _vm.activeStep === 2,
                expression: "activeStep === 1 || activeStep === 2"
              }
            ],
            staticClass: "big-line"
          }),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 1 || _vm.activeStep === 2,
                  expression: "activeStep === 1 || activeStep === 2"
                }
              ],
              ref: "step2Form",
              staticClass: "popover",
              attrs: {
                model: _vm.formData.step2,
                rules: _vm.rules.step2,
                "label-width": "100px",
                "label-position": "center"
              }
            },
            _vm._l(_vm.formData.step2.params, function(domain, index) {
              return _c(
                "div",
                { key: index + "k", staticClass: "param_keysClass" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "lodingItem-operationFrame flex",
                      staticStyle: { "flex-wrap": "wrap" }
                    },
                    [
                      domain.typeValue == "number"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "btn-type",
                                attrs: {
                                  prop: "params." + index + ".numberKey",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: true,
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: domain.numberKey,
                                    callback: function($$v) {
                                      _vm.$set(domain, "numberKey", $$v)
                                    },
                                    expression: "domain.numberKey"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  prop: "params." + index + ".numberVal",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    placeholder: "此处可填默认值"
                                  },
                                  model: {
                                    value: domain.numberVal,
                                    callback: function($$v) {
                                      _vm.$set(domain, "numberVal", $$v)
                                    },
                                    expression: "domain.numberVal"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      domain.typeValue == "boolean"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "btn-type",
                                attrs: {
                                  prop: "params." + index + ".booleanKey",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: true,
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: domain.booleanKey,
                                    callback: function($$v) {
                                      _vm.$set(domain, "booleanKey", $$v)
                                    },
                                    expression: "domain.booleanKey"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  prop: "params." + index + ".booleanVal",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: _vm.activeStep === 2,
                                    placeholder: "此处可填默认值"
                                  },
                                  model: {
                                    value: domain.booleanVal,
                                    callback: function($$v) {
                                      _vm.$set(domain, "booleanVal", $$v)
                                    },
                                    expression: "domain.booleanVal"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      domain.typeValue == "string"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "btn-type",
                                attrs: {
                                  prop: "params." + index + ".stringKey",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: domain.stringKey,
                                    callback: function($$v) {
                                      _vm.$set(domain, "stringKey", $$v)
                                    },
                                    expression: "domain.stringKey"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  prop: "params." + index + ".stringVal",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: { disabled: _vm.activeStep === 2 },
                                  model: {
                                    value: domain.stringVal,
                                    callback: function($$v) {
                                      _vm.$set(domain, "stringVal", $$v)
                                    },
                                    expression: "domain.stringVal"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      domain.typeValue == "map"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "btn-type",
                                attrs: {
                                  prop: "params." + index + ".mapParams",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请输入对象名称"
                                  },
                                  model: {
                                    value: domain.mapParams,
                                    callback: function($$v) {
                                      _vm.$set(domain, "mapParams", $$v)
                                    },
                                    expression: "domain.mapParams"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._l(domain.mapData, function(item, idx) {
                              return _c(
                                "div",
                                { key: idx + "kl", staticClass: "flex-item" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "btn-type",
                                      attrs: {
                                        prop:
                                          "params." +
                                          index +
                                          ".mapData." +
                                          idx +
                                          ".key",
                                        "label-width": "60px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "operationFrame-entity",
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: item.key,
                                          callback: function($$v) {
                                            _vm.$set(item, "key", $$v)
                                          },
                                          expression: "item.key"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "btn-type",
                                      attrs: {
                                        prop:
                                          "params." +
                                          index +
                                          ".mapData." +
                                          idx +
                                          ".value",
                                        "label-width": "60px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "operationFrame-entity",
                                        attrs: {
                                          disabled: _vm.activeStep === 2,
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: item.value,
                                          callback: function($$v) {
                                            _vm.$set(item, "value", $$v)
                                          },
                                          expression: "item.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ]
                        : _vm._e(),
                      domain.typeValue == "array"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "btn-type",
                                attrs: {
                                  prop: "params." + index + ".arrayParams",
                                  "label-width": "60px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请输入列表名称"
                                  },
                                  model: {
                                    value: domain.arrayParams,
                                    callback: function($$v) {
                                      _vm.$set(domain, "arrayParams", $$v)
                                    },
                                    expression: "domain.arrayParams"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._l(domain.arrayData, function(item, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx + "kl",
                                  staticClass: "flex-array-item",
                                  staticStyle: { "flex-direction": "column" }
                                },
                                [
                                  _c("div", { staticClass: "line" }),
                                  _vm._l(item.arrChildrenItem, function(m, k) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "flex-array-item",
                                        staticStyle: { "align-items": "center" }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "btn-type",
                                            attrs: {
                                              prop:
                                                "params." +
                                                index +
                                                ".arrayData." +
                                                idx +
                                                ".arrChildrenItem." +
                                                k +
                                                ".key",
                                              "label-width": "60px"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass:
                                                "operationFrame-entity",
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                disabled: true
                                              },
                                              model: {
                                                value: m.key,
                                                callback: function($$v) {
                                                  _vm.$set(m, "key", $$v)
                                                },
                                                expression: "m.key"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "btn-type",
                                            attrs: {
                                              prop:
                                                "params." +
                                                index +
                                                ".arrayData." +
                                                idx +
                                                ".arrChildrenItem." +
                                                k +
                                                ".value",
                                              "label-width": "60px"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass:
                                                "operationFrame-entity",
                                              attrs: {
                                                disabled: _vm.activeStep === 2,
                                                clearable: "",
                                                placeholder: "请输入"
                                              },
                                              model: {
                                                value: m.value,
                                                callback: function($$v) {
                                                  _vm.$set(m, "value", $$v)
                                                },
                                                expression: "m.value"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            }),
            0
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 3,
                  expression: "activeStep === 3"
                }
              ],
              ref: "step4Form",
              staticClass: "popover tipContent",
              attrs: { "label-width": "100px", "label-position": "center" }
            },
            [_c("div", [_vm._v(_vm._s(_vm.tip))])]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "step-actions" },
        [
          _vm.activeStep > 0
            ? _c("el-button", { on: { click: _vm.prevStep } }, [
                _vm._v("上一步")
              ])
            : _vm._e(),
          _vm.activeStep < 3
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.nextStep } },
                [
                  _vm._v(
                    _vm._s(_vm.activeStep === 2 ? "确认新增打包任务" : "下一步")
                  )
                ]
              )
            : _vm._e(),
          _vm.activeStep === 3
            ? _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.finish } },
                [_vm._v("完成")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }